<template>
  <div class="yali_pic">
    <div class="yali"></div>
    <!-- <button :class="$store.state.pressBut ? 'my_but' : 'my_but_active'" @click="mybut">压力展示</button> -->
    <!-- <div class="but" @click="mybut">
      <div :class="$store.state.pressBut ? 'but_yuan_1' : 'but_yuan_2'"></div>
      <p :class="$store.state.pressBut ? 'yali_font_1' : 'yali_font_2'">
        压力展示
      </p>
    </div> -->
    <div class="yali_1" @click="pressbut">
      <div :class="$store.state.pressBut ? 'press_but' : 'press_but_change'" ></div>
      <div :class="$store.state.pressBut?'press_font':'press_font_active'">管道压力</div>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      //isclick:true
      pressdata:[
        {
          id:"gs01",
          name:"宿舍3栋",
          colorvalue:""
        },
        {
          id:"gs02",
          name:"二区总表",
          colorvalue:""
        },
        {
          id:"gs03",
          name:"宿舍区绿化",
          colorvalue:""
        },
        {
          id:"gs04",
          name:"宿舍1栋",
          colorvalue:""
        },
        {
          id:"gs05",
          name:"宿舍2栋",
          colorvalue:""
        },
        {
          id:"gs06",
          name:"宿舍区泵房",
          colorvalue:""
        },
        {
          id:"gs07",
          name:"战训楼",
          colorvalue:""
        },
        {
          id:"gs08",
          name:"实训区",
          colorvalue:""
        },
        {
          id:"gs09",
          name:"食堂",
          colorvalue:""
        },
        {
          id:"gs10",
          name:"行政楼泵房",
          colorvalue:""
        },
        {
          id:"gs11",
          name:"行政楼泵房",
          colorvalue:""
        },
        {
          id:"gs12",
          name:"勤学楼外分区",
          colorvalue:""
        },
        {
          id:"gs13",
          name:"勤学楼外分区",
          colorvalue:""
        },
        {
          id:"gs14",
          name:"砺学楼外分区",
          colorvalue:""
        },
        {
          id:"gs15",
          name:"实验楼",
          colorvalue:""
        },
        {
          id:"gs16",
          name:"砺学楼",
          colorvalue:""
        },
        {
          id:"gs17",
          name:"实验楼外分区",
          colorvalue:""
        },
        {
          id:"gs18",
          name:"清雅湖绿化",
          colorvalue:""
        },
        {
          id:"gs19",
          name:"礼堂左侧消防",
          colorvalue:""

        },
        {
          id:"gs20",
          name:"礼堂右侧消防",
          colorvalue:""
        },
        {
          id:"gs21",
          name:"一区总表",
          colorvalue:""
        },
        {
          id:'gs22',
          name:"宿舍4栋",
          colorvalue:""
        },
        {
          id:"gs23",
          name:"一区总表",
          colorvalue:""
        },
        {
          id:"gs24",
          name:"行政楼绿化",
          colorvalue:""
        },
        {
          id:"gs25",
          name:"行政楼泵房",
          colorvalue:""
        },
        {
          id:"gs26",
          name:"勤学楼",
          colorvalue:""
        }
      ]
    };
  },
  methods: {
    pressbut() {
      //将压力值做一个判断，传入3d需要相应得颜色值
      // let press_color = [];
      this.$store.getters.shaixuan;
      this.$store.state.pressdata.forEach((item) => {
        if (item.pma_value >= 0 && item.pma_value < 0.3) {
          for(let i of this.pressdata){
            if(item.water_device_name==i.name){
              i.colorvalue="#00FFFF"
            }
          }
          // press_color[index] = "#00FFFF";
        } else if (item.pma_value >= 0.3 && item.pma_value < 0.5) {
          for(let i of this.pressdata){
            if(item.water_device_name==i.name){
              i.colorvalue="#00FF00"
            }
          }
          // press_color[index] = "#00FF00";
        } else if (item.pma_value >= 0.5 && item.pma_value < 0.7) {
          for(let i of this.pressdata){
            if(item.water_device_name==i.name){
              i.colorvalue="#FFFF00"
            }
          }
          // press_color[index] = "#FFFF00";
        } else if (item.pma_value >= 0.7 && item.pma_value < 1.2) {
          for(let i of this.pressdata){
            if(item.water_device_name==i.name){
              i.colorvalue="#FF0000"
            }
          }
          // press_color[index] = "#FF0000";
        }
      });
      for(let i of this.pressdata){
        if(i.colorvalue==""){
          i.colorvalue="#00FF00"
        }
      }
      // for (var i = 0; i < 27 - press_color.length; i++) {
      //   press_color.push("#00FF00");
      // }
      //FF4500
      this.$store.commit("environmentchange_1")
      document.getElementById("iframe").contentWindow.MMAPI.changePress(this.pressdata,this.$store.state.pressBut);
      //按钮状态的控制
      this.$store.commit("changepressbut_2");
      this.$store.commit("changegive_water_1");
      this.$store.commit("changegive_xiaofang_1");
      this.$store.commit("changewatchshow_3");
      this.$store.commit("changefamenshow_2");
      this.$store.commit("changexiaofangshow_2");
      this.$store.commit("tumingvaluechange"); //透明度数值还原

      if(this.$store.state.give_water&this.$store.state.give_xiaofang){
        // 还原classname
        setTimeout(()=>{
          this.$store.commit("changebutshowfalse");
          this.$store.commit('change_shebei_true');
          document.getElementById('shebei_but').className = "but_3"
        },100)
      }
    },
  },
};
</script>

<style scoped>
.yali_pic {
  width: 19vw;
  height: 4vh;
  position: fixed;
  bottom: 2vh;
  left: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* align-items: center; */
}
.yali {
  width: 13.85vw;
  height: 3.05vh;
  background: url("@/assets/pengshui_press.png") no-repeat center center;
  background-size: 100% 100%;  
  
}

.but {
  width: 4vw;
  height: 4vh;
  display: flex;
  color: #ffffff;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
}
.but_yuan_1 {
  width: 12px;
  height: 12px;
  border: none;
  background: url("@/assets/pengshui_yuan_1.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

}
.but_yuan_2 {
  width: 12px;
  height: 12px;
  border: none;
  background: url("@/assets/pengshui_yuan.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.yali_font_1 {
  color: #ffffff;
  font-size: 12px;
  width: 3vw;
  flex: 1;
  /* height: 2vh; */
  /* line-height: 3.05vh; */
}
.yali_font_2 {
  color: #fec500;
  font-size: 12px;
  width: 3vw;
  flex: 1;
  /* height: 2vh; */
  /* line-height: 3.05vh; */
}
.my_but{
  height: 80%;
  border: 3px solid #ccc;
  border-radius: 10%;
}
.my_but_active{
  height: 80%;
  border: 3px solid #fec500;
  border-radius: 10%;
  background: #fec500;
  color: #fff;
}
.press_but {
  background: url("@/assets/press_false.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.3vw;
  height: 3.5vh;
  cursor: pointer;
}
.press_but_change {
  background: url("@/assets/press_true.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.3vw;
  height: 3.5vh;
  cursor: pointer;
}
.yali_1{
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* border: 1px solid #ccc; */

}
.press_font{
  font-size: 12px;
  color: #ffffff;
}
.press_font_active{
  font-size: 12px;
  color: #fec500;
}
</style>